import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../services/api";
import auth from "../../services/auth";
import Spinner from "elements/Spinner";

/**
 * Landing for the "open the site logged in" activation option. The backend
 * redirects a just-verified player here with a one-time code; we exchange it
 * for a session via the existing activateLogin path, then hard-reload into the
 * logged-in app. On any failure we fall back to the login module + message.
 */
const AccountActivation = () => {
  const { email, code } = useParams();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      // Already signed in (e.g. navigated back to this URL): don't attempt to
      // re-exchange a spent one-time code, just go home.
      if (auth.isAuthenticated()) {
        window.location.href = "/";
        return;
      }
      try {
        const res = await api.post("/login", {
          email: decodeURIComponent(email || ""),
          code: code,
          login_type: "activateLogin",
          forceLogin: true,
        });
        if (
          !cancelled &&
          res.status === 200 &&
          res.data &&
          res.data.user &&
          auth.login(res.data.user)
        ) {
          window.location.href = "/";
          return;
        }
      } catch (e) {
        // fall through to the login-with-message fallback
      }
      if (!cancelled) {
        window.location.href = "/?verified=1&showLogin=1";
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [email, code]);

  return <Spinner />;
};

export default AccountActivation;
